import React from 'react'
import ThemeProvider from './providers/ThemeProvider'
import { LanguageProvider } from './providers/LanguageProvider'
import MainLayout from './layouts/MainLayout/MainLayout'
import { Routes, Route } from "react-router"
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import { Button } from 'antd'
import { AuthProvider } from './auth/AuthProvider'
import PrivateRoute from './routes/PrivateRoute'
import InvoiceProfiles from './pages/invoice/InvoiceProfiles'

import { store } from './store'
import { Provider } from 'react-redux'
import ProfilePage from './pages/ProfilePage'
import ForgotPassword from './pages/ForgotPassword'
import Register from './pages/RegisterPage'
import ResetPassword from './pages/ResetPassword'
import SessionsPage from './pages/SessionsPage'
import ProductsPage from './pages/ProductsPage'
import Subscriptions from './pages/Subscription'
import SubscriptionDetail from './pages/subscriptions/SubscriptionDetail'
import ResolverPage from './pages/resolver/ResolverPage';
import Transactions from './pages/TransactionsPage'
import SecurityPage from './pages/SecurityPage'
import SupportPage from './pages/SupportPage'
import SecurityPassword from './pages/SecurityPassword'
import VerifyEmailPage from './pages/VerifyEmailPage'
import SetupWizardPage from './pages/SetupWizardPage'
import LoginWithToken from './pages/LoginWithToken'


const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/login-with-token" element={<LoginWithToken />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              <Route element={<PrivateRoute />}>
                <Route element={<MainLayout />}>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/invoice-profiles" element={<InvoiceProfiles />} />
                  <Route path="/subscriptions/:id" element={<SubscriptionDetail />} />
                  <Route path="/resolver/:product" element={<ResolverPage />} />
                  <Route path="/subscriptions" element={<Subscriptions />} />
                  <Route path="/my-invoices" element={<Transactions />} />
                  <Route path="/setup-wizard" element={<SetupWizardPage />} />

                  <Route path="/profile" element={<ProfilePage />} />
                  {/* <Route path="/products" element={<ProductsPage />} /> */}
                  <Route path="/security" element={<SecurityPage />} />
                  <Route path="/security/sessions" element={<SessionsPage />} />
                  <Route path="/security/password" element={<SecurityPassword />} />
                  <Route path="/support" element={<SupportPage />} />
                </Route>
              </Route>
            </Routes>
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </Provider>
  )
}

export default App
